import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../types/multi-error';
import { graphqlClient } from '../graphql-client';

const MUTATION = gql`
    mutation UserStatsAddEmotionEpisode($episodeUid: String!){
        user_stats_add_emotion_episode (episodeUid: $episodeUid) {
            success,
        }
    }
`;

export async function addEmotionEpisodeToUser(episodeUid: string): Promise<{success: boolean}> {
    const result: FetchResult<{ user_stats_add_emotion_episode: {success: boolean} }> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { episodeUid },
        errorPolicy: 'all',
    });

    if(!result.data || (result.errors && result.errors.length)) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.user_stats_add_emotion_episode;
}
